// truncate truncates a given `input` string after `chars` and appends
// an `ellipsis`
export function truncate(input, chars = 50, ellipsis = '...') {
    if (input == null) return;
    if (typeof input !== 'string') return input;

    if (input.length > chars) {
        return input.substring(0, chars) + ellipsis;
    }
    return input;
}